export function copyText(text?: string | null): Promise<void> {
  return new Promise((resolve, reject) => {
    if (text) {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          resolve()
        })
        .catch((err) => {
          reject(err)
        })
    } else {
      reject(new Error('No text provided to copy.'))
    }
  })
}
